import { buildSearchEngine, getOrganizationEndpoints, SearchEngine } from '@coveo/headless';
import isCoveoAnalyticsEnabled from '../isCoveoAnalyticsEnabled';

const DEFAULT_ORG_ID = 'iqviafnaquintilesimsnonproduction12c6jth8d';
const DEFAULT_SITES_ACCESS_TOKEN = 'xx7f5138ce-1ddd-4e63-a922-0730d9795d4b';
const DEFAULT_SITES_SEARCH_HUB = 'AvacareProtocolSitesDev';

export interface BuildSitesHeadlessEngineOptions {
  /** When false, Coveo does not emit search analytics (saved sites carousel). */
  analyticsEnabled?: boolean;
}

/** Builds a new sites-index Coveo Headless engine (call once per singleton module). */
export function buildSitesHeadlessEngine(
  options: BuildSitesHeadlessEngineOptions = {}
  // eslint-disable-next-line @typescript-eslint/ban-types -- Coveo SearchEngine default state
): SearchEngine<{}> {
  const orgId = process.env.NEXT_PUBLIC_COVEO_ORG_ID || DEFAULT_ORG_ID;
  const analyticsEnabled = options.analyticsEnabled ?? isCoveoAnalyticsEnabled();

  return buildSearchEngine({
    configuration: {
      organizationId: orgId,
      accessToken: process.env.NEXT_PUBLIC_COVEO_SITES_ACCESSTOKEN || DEFAULT_SITES_ACCESS_TOKEN,
      organizationEndpoints: getOrganizationEndpoints(orgId),
      search: {
        searchHub: process.env.NEXT_PUBLIC_COVEO_SITES_SEARCHHUB || DEFAULT_SITES_SEARCH_HUB,
      },
      analytics: {
        enabled: analyticsEnabled,
        ...(analyticsEnabled && { originLevel3: '/locations' }),
      },
    },
  });
}
